export const HORIZONTAL_AD = 2;
export const VERTICAL_AD = 1;
